// Types
export type { SrcSet } from './types/responsiveImage';
export type {
  ButtonProps,
  ButtonLogoutProps,
  ButtonLoginProps,
  SignupLinkProps,
} from './types/button';
export type { InputLoginByOtpAuthKeyProps } from './types/inputLoginByOtpAuthKey';
export type { ToastProps } from './types/toast';
export type { DialogProps, DialogLevel } from './types/dialog';
export type { DialogWithButtonConfigsProps } from './types/dialogWithButtonConfigs';
export type { NavbarHelpButtonProps } from './types/navbarHelpButton';
export type { TrackingPageType } from './types/tracking';
export type { SignupTermsOfServiceProps } from './types/signupTermsOfService';
export type {
  LoginByPasswordFormShape,
  LoginByOtpFormShape,
  BiometricsLoginByPasswordFormShape,
} from './types/form';
export type { LoginByPasswordFooterProps } from './types/loginByPasswordFooter';
export type { LoginByOtpOneCredentialOptionalRequireAuthKeyProps } from './types/loginByOtpOneCredentialOptionalRequireAuthKey';
export type { SignupByOtpOneCredentialOptionalRequireAuthKeyProps } from './types/signupByOtpOneCredentialOptionalRequireAuthKey';
export { AuthSource } from './types/auth';
export type {
  AvailableLoginMethodsConfig,
  GetAvailableLoginMethodConfigParameter,
} from './types/availableLoginMethods';
export type {
  RedirectWithToCNonceProps,
  RedirectAfterOneCredentialDelinkProps,
} from './types/redirect';
export type {
  GetChangeEmailHelpLinkFunction,
  GetChangeEmailNativeVerificationLinkFunction,
  GetChangePasswordHelpLinkFunction,
  GetChangePasswordNativeVerificationLinkFunction,
} from './types/urlUtils/customerService';
export type {
  GetIvsClientIdFunction,
  GetLoginIvsEventTypeFunction,
  GetOneCredentialLoginIvsEventTypeFunction,
} from './types/ivs/config';
export type { LoginByPasswordOneCredentialRequireAuthKeyProps } from './types/loginByPasswordOneCredentialRequireAuthKey';
export type { AddOrChangePhoneExitHandling } from './types/addOrChangePhoneExitHandling';
export type { AddOrChangePasswordExitHandling } from './types/addOrChangePasswordExitHandling';
export { PasswordUseCase } from './types/addOrChangePasswordExitHandling';
export type { AddOrChangeEmailExitHandling } from './types/addOrChangeEmailExitHandling';
export type {
  GetThirdPartyAuthConfigFunction,
  GetThirdPartyClientIdFunction,
  GetThirdPartyFlowTriggerUrlFunction,
} from './types/thirdparty/config';
export { ThirdPartyFlowUseCase } from './types/thirdparty/config';
export { AbTestExperiments } from './types/abtest';
export type {
  AbTestExperiment,
  AbTestExperimentEvaluatorFunction,
  AbTestExperimentEvaluatorMap,
  HideBiometricsSetupLaterExperimentEvaluator,
} from './types/abtest';
import { WithToastProps } from '@shopee-user/with-toast';
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

enum ResponsiveImageUseCase {
  AuthBackground = 'auth-background',
  AuthLogo = 'auth-logo',
  DelinkLogo = 'delink-logo',
}

export enum LinkStatus {
  Unlinked = 0, // ToB Account that is not linked to any account (in ToB One Credential, it will be the credential holder)
  ToCLinked = 1, // ToC Linked Account
  ToBLinked = 2, // ToB Linked Account (has no credential, linked to a different ToB Account that holds the user credential)
}

export enum AccountType {
  ToB = 'tob',
  ToCOneCredential = 'toc-one-credential',
  ToBOneCredential = 'tob-one-credential',
}

export type OneCredentialDelinkSetPasswordFormShape = {
  newPassword: 'string';
  newPasswordRepeat: 'string';
};

export type GetBiometricsReloginTypeFunctionParameter = {
  linkStatus?: LinkStatus;
};

export type ThirdPartyAuthenticationComponentsProps = {
  trackingUtils: {
    trackClickGoogleButton: () => void;
  };
  showToast: WithToastProps['showToast'];
  webViewOpenExternalLink: WithUserWebViewProps['webViewOpenExternalLink'];
  webViewFetchToBDataFromNative: WithUserWebViewProps['webViewFetchToBDataFromNative'];
};

export type LoginByPasswordSkeletonTrackingUtils = {
  trackingUtils: {
    trackClickRedirectSignupButton?: () => void;
    trackClickRedirectToLoginWithPhoneButton?: () => void;
    trackClickBackButton?: () => void;
    trackClickHelpButton?: () => void;
  };
};

export { ResponsiveImageUseCase };
export type { ShouldEnableQuickLoginExperimentEvaluator } from './types/abtest';
